/**
 * This file was auto-generated, do not edit manually.
 *
 * Run `pnpm gen:routes` to re-generate this file.
 */

import { route, stringParser } from "typesafe-routes";

export const RouteIds = [
  "root",
  "auth",
  "authIndex",
  "authIframe",
  "authLayout",
  "authContinue",
  "authPasswordSetup",
  "authPasswordReset",
  "authPassword",
  "authMfaSetup",
  "authMfa",
  "authLoginSimple",
  "authLogin",
  "authLogout",
  "authNotFound",
  "protectedRoutes",
  "dashboard",
  "account",
  "accountProfile",
  "accountSecurity",
  "admin",
  "events",
  "eventsIndex",
  "eventsRollback",
  "event",
  "auditing",
  "auditingIndex",
  "fundFamilies",
  "fundFamilyList",
  "fundFamily",
  "fundFamilyIndex",
  "fundFamilyLayout",
  "capitalActivity",
  "capitalActivityIndex",
  "capitalActivityCapitalActivityEvent",
  "capitalActivityCapitalActivityEventIndex",
  "capitalActivityCapitalActivityEventNotices",
  "capitalActivityCapitalActivityEventCalls",
  "capitalActivityCapitalActivityEventAllocation",
  "capitalActivityCapitalActivityEventBreakdown",
  "feeBasisNotification",
  "capitalActivityCapitalActivityCallReallocation",
  "capitalActivityCapitalActivityEventReallocationUpdate",
  "capitalActivityCapitalActivityEventReallocationReview",
  "capitalActivityCapitalActivityEventDistributions",
  "capitalActivityEventDistributions",
  "capitalActivityEventDistributionAllocation",
  "capitalActivityEventDistributionBreakdown",
  "capitalActivityCapitalActivityEventEqualization",
  "capitalActivityCapitalActivityEventEqualizationView",
  "capitalActivityCapitalActivityEventWaterfall",
  "capitalActivityCapitalActivityEventWaterfallReview",
  "capitalActivityCapitalActivityEventWaterfallReviewFundPreferredReturn",
  "capitalActivityCapitalActivityEventWaterfallReviewRoutes",
  "capitalActivityCapitalActivityEventWaterfallReviewFund",
  "capitalActivityCapitalActivityEventWaterfallReviewInvestorBreakdown",
  "reviewInvestmentClassifications",
  "capitalActivityCapitalActivityEventWaterfallReviewBreakdown",
  "capitalActivityCapitalActivityEventWaterfallReviewBreakdownInvestor",
  "capitalActivityCapitalActivityEventWaterfallReviewBreakdownInvestorPreferredReturn",
  "capitalActivityCapitalActivityEventWaterfallHybrid",
  "capitalActivityCapitalActivityEventWaterfallHybridStatus",
  "capitalActivityCapitalActivityEventWaterfallHybridSummary",
  "hybridWaterfallInvestmentReview",
  "fundFamilyCommitments",
  "fundFamilyCommitmentsIndex",
  "fundFamilyCommitmentsTab",
  "fundFamilyCommitmentsClosingsTab",
  "fundFamilyCommitmentsTransfersTab",
  "fundFamilyCommitmentsFee",
  "fundFamilyCommitmentsFeeOverride",
  "fundFamilyCommitmentsCommitment",
  "fundFamilyCommitmentsCommitmentActivity",
  "fundFamilyCommitmentsCommitmentProfile",
  "fundFamilyCommitmentsCommitmentFees",
  "fundFamilyCommitmentsCommitmentWaterfall",
  "fundFamilyCommitmentsCommitmentPerformance",
  "fundFamilyCommitmentsCancelCorrect",
  "fundFamilyCommitmentsCancelCorrectClass",
  "fundFamilyCommitmentsCancelCorrectFeeTrueUp",
  "fundFamilyCommitmentsCancelCorrectEqualization",
  "fundFamilyCommitmentsCancelCorrectHistorical",
  "fundFamilyCommitmentsInvestorEntities",
  "fundFamilyCommitmentsInvestorEntitiesInvestorEntity",
  "fundFamilyCommitmentsInvestorEntitiesInvestorEntityTabActivity",
  "fundFamilyCommitmentsInvestorEntitiesInvestorEntityTabProfile",
  "fundFamilyCommitmentsInvestorEntitiesInvestorEntityTabCommitments",
  "fundFamilyCommitmentsInvestorEntitiesInvestorEntityTabPerformance",
  "fundFamilyCommitmentsInvestorEntitiesInvestorEntityCommitments",
  "fundFamilyCommitmentsInvestorEntitiesInvestorEntityCommitmentsFee",
  "fundFamilyCommitmentsInvestorEntitiesInvestorEntityCommitmentsFeeOverride",
  "fundFamilyCommitmentsInvestorEntitiesInvestorEntityCommitmentsCommitment",
  "fundFamilyCommitmentsInvestorEntitiesInvestorEntityCommitmentsCommitmentActivity",
  "fundFamilyCommitmentsInvestorEntitiesInvestorEntityCommitmentsCommitmentProfile",
  "fundFamilyCommitmentsInvestorEntitiesInvestorEntityCommitmentsCommitmentFees",
  "fundFamilyCommitmentsInvestorEntitiesInvestorEntityCommitmentsCommitmentWaterfall",
  "fundFamilyCommitmentsInvestorEntitiesInvestorEntityCommitmentsCommitmentPerformance",
  "fundFamilyCommitmentsInvestorEntitiesInvestorEntityCommitmentsCancelCorrect",
  "fundFamilyCommitmentsInvestorEntitiesInvestorEntityCommitmentsCancelCorrectClass",
  "fundFamilyCommitmentsInvestorEntitiesInvestorEntityCommitmentsCancelCorrectFeeTrueUp",
  "fundFamilyCommitmentsInvestorEntitiesInvestorEntityCommitmentsCancelCorrectEqualization",
  "fundFamilyCommitmentsInvestorEntitiesInvestorEntityCommitmentsCancelCorrectHistorical",
  "investorTransfers",
  "investorTransfersCreate",
  "investorTransfersSetup",
  "investorTransfersSetupDetails",
  "investorTransfersSetupTransferees",
  "investorTransfersSetupDocuments",
  "investorTransfersSetupReview",
  "investorTransfersSetupSetupFinalize",
  "investorTransfersView",
  "closing",
  "closingEdit",
  "closingCommitments",
  "equalizationFirstClosingEqualization",
  "equalizationFirstClosingFeeTrueUp",
  "equalizationSecondClosingFeeTrueUp",
  "equalizationSecondClosingEqualization",
  "creditFacilities",
  "creditFacilitiesIndex",
  "creditFacilitiesCreditFacility",
  "creditFacilitiesCreditFacilityDashboard",
  "creditFacilitiesCreditFacilityPrincipal",
  "creditFacilitiesCreditFacilityExpenses",
  "creditFacilitiesCreditFacilityBorrowingBase",
  "creditFacilitiesCreditFacilitySetup",
  "creditFacilitiesCreditFacilitySetupDetails",
  "creditFacilitiesCreditFacilitySetupCommitments",
  "creditFacilitiesCreditFacilitySetupLoan",
  "creditFacilitiesCreditFacilitySetupBorrowingBase",
  "creditFacilitiesCreditFacilitySetupBorrowingBaseReview",
  "creditFacilitiesCreditFacilitySetupInvestorBorrowingBase",
  "creditFacilitiesCreditFacilityEvent",
  "creditFacilitiesCreditFacilityEventDrawdown",
  "creditFacilitiesCreditFacilityEventDrawdownUpdate",
  "creditFacilitiesCreditFacilityEventDrawdownReview",
  "creditFacilitiesCreditFacilityEventPaydownLegacy",
  "creditFacilitiesCreditFacilityEventPaydownUpdateLegacy",
  "creditFacilitiesCreditFacilityEventPaydownReviewLegacy",
  "creditFacilitiesCreditFacilityEventPaydown",
  "creditFacilitiesCreditFacilityEventPaydownUpdate",
  "creditFacilitiesCreditFacilityEventPaydownReview",
  "creditFacilitiesCreditFacilityEventReallocation",
  "creditFacilitiesCreditFacilityEventReallocationSelect",
  "creditFacilitiesCreditFacilityEventReallocationSplit",
  "creditFacilitiesCreditFacilityEventReallocationReview",
  "creditFacilitiesCreditFacilityEventMergeTranches",
  "creditFacilitiesCreditFacilityEventMergeTranche",
  "creditFacilitiesCreditFacilityEventMergeTrancheReview",
  "creditFacilitiesCreditFacilityEventExpenses",
  "creditFacilitiesCreditFacilityEventExpensesPost",
  "creditFacilitiesCreditFacilityEventExpensesLoan",
  "details",
  "creditFacilitiesCreditFacilityEventExpensesLoanAdjust",
  "fees",
  "feesIndex",
  "feesDashboard",
  "feePostingTab",
  "feeBasisTab",
  "feeChargeEventPosted",
  "feeChargeEventPostedBreakdown",
  "feeChargeEventPostedInvestor",
  "feeChargeEventPostedUse",
  "feeBreakdownManagementFeeCatchUp",
  "feeBreakdownCancelCorrectFeeAdjustments",
  "feeBreakdownHistoricalBasisFeeTrueUp",
  "feesPost",
  "feesPostUseBreakdown",
  "feesPostReviewBasis",
  "feesPostReviewBasisHistoricalTrueUp",
  "feesPostReviewBasisBreakdown",
  "feesPostApplyOffsets",
  "feesPostReviewFees",
  "lateOffsets",
  "lateOffsetsApplyOffsets",
  "lateOffsetsReviewFees",
  "fundFamilySetup",
  "fundFamilySetupIndex",
  "fundFamilySetupCommitments",
  "fundFamilySetupCommitmentsIndex",
  "fundFamilySetupCommitmentsFeeOverride",
  "fundFamilySetupCommitmentsCommitment",
  "fundFamilySetupCommitmentsCommitmentBasic",
  "fundFamilySetupCommitmentsCommitmentLetter",
  "fundFamilySetupCommitmentsCommitmentFees",
  "fundFamilySetupCommitmentsCommitmentWaterfall",
  "fundFamilySetupClasses",
  "fundFamilySetupClassesIndex",
  "fundFamilySetupClassesEdit",
  "basic",
  "fundFamilySetupClassesEditFees",
  "fundFamilySetupClassesEditWaterfall",
  "fundFamilySetupClassesEditCommitments",
  "fundFamilySetupClassesFee",
  "fundFamilySetupClassesFeeOverride",
  "fundFamilySetupClosing",
  "fundFamilySetupClosingPage",
  "fundFamilySetupClosingCommitments",
  "fundFamilySetupFund",
  "fundFamilySetupFundIndex",
  "fundFamilySetupFundBasic",
  "fundFamilySetupFundDates",
  "fundFamilySetupFundFeesList",
  "fundFamilySetupFundWaterfall",
  "fundFamilySetupFundCalculations",
  "fundFamilySetupFundAllocations",
  "fundFamilySetupFundTransactionCodes",
  "fundFamilySetupFundFees",
  "fundFamilySetupFundFeesAdd",
  "fundFamilySetupFundFeesView",
  "fundFamilySetupFundFeesEdit",
  "calculationCreate",
  "calculationEdit",
  "basisEdit",
  "transactionCodesEdit",
  "fundFamilySetupEntities",
  "fundFamilySetupEntitiesIndex",
  "fundFamilySetupEntitiesList",
  "fundFamilySetupEntitiesAllocationsList",
  "fundFamilySetupEntitiesEntity",
  "fundFamilySetupEntitiesEditPage",
  "fundFamilySetupEntitiesEntityDetails",
  "fundFamilySetupEntitiesEntityAllocationsList",
  "fundFamilySetupEntitiesEntityAllocations",
  "fundFamilySetupEntitiesEntityAllocationsCreate",
  "fundFamilySetupEntitiesEntityAllocationsEdit",
  "fundFamilySetupEntitiesEntityAllocationsEditBasic",
  "fundFamilySetupEntitiesEntityAllocationsEditInvesting",
  "fundFamilySetupEntitiesEntityAllocationsSetup",
  "fundFamilySetupEntitiesEntityAllocationsSetupDetails",
  "fundFamilySetupEntitiesEntityAllocationsSetupEntities",
  "fundFamilySetupEntitiesAllocations",
  "fundFamilySetupEntitiesAllocationsCreate",
  "fundFamilySetupEntitiesAllocationsEdit",
  "fundFamilySetupEntitiesAllocationsEditBasic",
  "fundFamilySetupEntitiesAllocationsEditInvesting",
  "fundFamilySetupEntitiesAllocationsSetup",
  "fundFamilySetupEntitiesAllocationsSetupDetails",
  "fundFamilySetupEntitiesAllocationsSetupEntities",
  "fundFamilySetupNotices",
  "setupNotices",
  "setupNoticesSchema",
  "setupNoticesConfig",
  "setupNoticesCapitalCall",
  "setupNoticesDistribution",
  "fundFamilySetupCreditFacilities",
  "fundFamilySetupCreditFacilitiesIndex",
  "fundFamilySetupCreditFacilitiesCreditFacility",
  "fundFamilySetupCreditFacilitiesCreditFacilityDetails",
  "fundFamilySetupCreditFacilitiesCreditFacilityLoan",
  "fundFamilySetupCreditFacilitiesCreditFacilitySettingsBorrowingBase",
  "fundFamilySetupCreditFacilitiesCreditFacilitySettingsBorrowingBaseEdit",
  "fundFamilySetupInvestorEntities",
  "fundFamilySetupInvestorEntitiesInvestorEntity",
  "fundFamilySetupInvestorEntitiesInvestorEntityTabActivity",
  "fundFamilySetupInvestorEntitiesInvestorEntityTabProfile",
  "fundFamilySetupInvestorEntitiesInvestorEntityTabCommitments",
  "fundFamilySetupInvestorEntitiesInvestorEntityTabPerformance",
  "fundFamilySetupInvestorEntitiesInvestorEntityCommitments",
  "fundFamilySetupInvestorEntitiesInvestorEntityCommitmentsFee",
  "fundFamilySetupInvestorEntitiesInvestorEntityCommitmentsFeeOverride",
  "fundFamilySetupInvestorEntitiesInvestorEntityCommitmentsCommitment",
  "fundFamilySetupInvestorEntitiesInvestorEntityCommitmentsCommitmentActivity",
  "fundFamilySetupInvestorEntitiesInvestorEntityCommitmentsCommitmentProfile",
  "fundFamilySetupInvestorEntitiesInvestorEntityCommitmentsCommitmentFees",
  "fundFamilySetupInvestorEntitiesInvestorEntityCommitmentsCommitmentWaterfall",
  "fundFamilySetupInvestorEntitiesInvestorEntityCommitmentsCommitmentPerformance",
  "fundFamilySetupInvestorEntitiesInvestorEntityCommitmentsCancelCorrect",
  "fundFamilySetupInvestorEntitiesInvestorEntityCommitmentsCancelCorrectClass",
  "fundFamilySetupInvestorEntitiesInvestorEntityCommitmentsCancelCorrectFeeTrueUp",
  "fundFamilySetupInvestorEntitiesInvestorEntityCommitmentsCancelCorrectEqualization",
  "fundFamilySetupInvestorEntitiesInvestorEntityCommitmentsCancelCorrectHistorical",
  "fundFamilySetupInvestorEntitiesInvestorEntityCommitmentsInvestorEntities",
  "fundFamilySetupInvestorEntitiesInvestorEntityCommitmentsInvestorEntitiesInvestorEntity",
  "fundFamilySetupInvestorEntitiesInvestorEntityCommitmentsInvestorEntitiesInvestorEntityTabActivity",
  "fundFamilySetupInvestorEntitiesInvestorEntityCommitmentsInvestorEntitiesInvestorEntityTabProfile",
  "fundFamilySetupInvestorEntitiesInvestorEntityCommitmentsInvestorEntitiesInvestorEntityTabCommitments",
  "fundFamilySetupInvestorEntitiesInvestorEntityCommitmentsInvestorEntitiesInvestorEntityTabPerformance",
  "fundFamilyInvestments",
  "investmentIndex",
  "investment",
  "investmentActivity",
  "investmentSetupProfile",
  "fundFamilyInvestmentsCreate",
  "portfolios",
  "portfolio",
  "portfolioActivity",
  "portfolioProfile",
  "portfolioInvestments",
  "financial-reporting",
  "index",
  "hypoCreate",
  "hypoWaterfallEdit",
  "hypotheticalWaterfall",
  "irr",
  "pref-breakdown",
  "investor-pref-breakdown",
  "investor-waterfall-details",
  "hypotheticalWaterfallDesignateProtectedCarry",
  "hypotheticalWaterfallReview",
  "investorNav",
  "waterfallDetails",
  "performance",
  "fundFamilyNotFound",
  "reports",
  "availableReportsList",
  "settings",
  "users",
  "entities",
  "entitiesList",
  "entitiesBulkAddBanks",
  "entitiesBulkAddContacts",
  "entitiesEntity",
  "entitiesEntityDetails",
  "transactions",
  "investorEntities",
  "investorEntitiesInvestorEntity",
  "investorEntitiesInvestorEntityTabActivity",
  "investorEntitiesInvestorEntityTabProfile",
  "investorEntitiesInvestorEntityTabCommitments",
  "investorEntitiesInvestorEntityTabPerformance",
  "investorEntitiesInvestorEntityCommitments",
  "investorEntitiesInvestorEntityCommitmentsFee",
  "investorEntitiesInvestorEntityCommitmentsFeeOverride",
  "investorEntitiesInvestorEntityCommitmentsCommitment",
  "investorEntitiesInvestorEntityCommitmentsCommitmentActivity",
  "investorEntitiesInvestorEntityCommitmentsCommitmentProfile",
  "investorEntitiesInvestorEntityCommitmentsCommitmentFees",
  "investorEntitiesInvestorEntityCommitmentsCommitmentWaterfall",
  "investorEntitiesInvestorEntityCommitmentsCommitmentPerformance",
  "investorEntitiesInvestorEntityCommitmentsCancelCorrect",
  "investorEntitiesInvestorEntityCommitmentsCancelCorrectClass",
  "investorEntitiesInvestorEntityCommitmentsCancelCorrectFeeTrueUp",
  "investorEntitiesInvestorEntityCommitmentsCancelCorrectEqualization",
  "investorEntitiesInvestorEntityCommitmentsCancelCorrectHistorical",
  "investorEntitiesInvestorEntityCommitmentsInvestorEntities",
  "investorEntitiesInvestorEntityCommitmentsInvestorEntitiesInvestorEntity",
  "investorEntitiesInvestorEntityCommitmentsInvestorEntitiesInvestorEntityTabActivity",
  "investorEntitiesInvestorEntityCommitmentsInvestorEntitiesInvestorEntityTabProfile",
  "investorEntitiesInvestorEntityCommitmentsInvestorEntitiesInvestorEntityTabCommitments",
  "investorEntitiesInvestorEntityCommitmentsInvestorEntitiesInvestorEntityTabPerformance",
  "internal",
  "internalAuditing",
  "featureFlags",
  "featureFlag",
  "featureFlagDetails",
  "featureFlagEdit",
  "provisioning",
  "provisioningIndex",
  "customersTab",
  "usersTab",
  "customer",
  "shadow",
  "shadowIndex",
  "templateTab",
  "templateLoadTab",
  "templateExportTab",
  "shadowTemplate",
  "template",
  "templateExport",
  "templateLoad",
  "templateEvent",
  "integrationTesting",
  "integrationTestingIndex",
  "activity",
  "configurations",
  "integrationTestingReport",
  "integrationTestingReportUpdate",
  "configuration",
  "investors",
  "investorsIndex",
  "investorsInvestor",
  "investorsInvestorIndex",
  "investorsInvestorView",
  "investorsInvestorActivity",
  "investorsInvestorProfile",
  "investorsInvestorFunds",
  "investorsInvestorPerformance",
  "investorsInvestorEntitiesList",
  "investorsInvestorEntities",
  "investorsInvestorEntitiesInvestorEntity",
  "investorsInvestorEntitiesInvestorEntityTabActivity",
  "investorsInvestorEntitiesInvestorEntityTabProfile",
  "investorsInvestorEntitiesInvestorEntityTabCommitments",
  "investorsInvestorEntitiesInvestorEntityTabPerformance",
  "investorsInvestorEntitiesInvestorEntityCommitments",
  "investorsInvestorEntitiesInvestorEntityCommitmentsFee",
  "investorsInvestorEntitiesInvestorEntityCommitmentsFeeOverride",
  "investorsInvestorEntitiesInvestorEntityCommitmentsCommitment",
  "investorsInvestorEntitiesInvestorEntityCommitmentsCommitmentActivity",
  "investorsInvestorEntitiesInvestorEntityCommitmentsCommitmentProfile",
  "investorsInvestorEntitiesInvestorEntityCommitmentsCommitmentFees",
  "investorsInvestorEntitiesInvestorEntityCommitmentsCommitmentWaterfall",
  "investorsInvestorEntitiesInvestorEntityCommitmentsCommitmentPerformance",
  "investorsInvestorEntitiesInvestorEntityCommitmentsCancelCorrect",
  "investorsInvestorEntitiesInvestorEntityCommitmentsCancelCorrectClass",
  "investorsInvestorEntitiesInvestorEntityCommitmentsCancelCorrectFeeTrueUp",
  "investorsInvestorEntitiesInvestorEntityCommitmentsCancelCorrectEqualization",
  "investorsInvestorEntitiesInvestorEntityCommitmentsCancelCorrectHistorical",
  "investorsInvestorEntitiesInvestorEntityCommitmentsInvestorEntities",
  "investorsInvestorEntitiesInvestorEntityCommitmentsInvestorEntitiesInvestorEntity",
  "investorsInvestorEntitiesInvestorEntityCommitmentsInvestorEntitiesInvestorEntityTabActivity",
  "investorsInvestorEntitiesInvestorEntityCommitmentsInvestorEntitiesInvestorEntityTabProfile",
  "investorsInvestorEntitiesInvestorEntityCommitmentsInvestorEntitiesInvestorEntityTabCommitments",
  "investorsInvestorEntitiesInvestorEntityCommitmentsInvestorEntitiesInvestorEntityTabPerformance",
  "protectedNotFound",
  "notFound",
] as const;
export type RouteId = (typeof RouteIds)[number];
export const rootRoute = route(
  "/",
  {},
  {
    auth: route(
      "auth",
      {},
      {
        index: route("", {}, {}),
        iframe: route("iframe", {}, {}),
        continue: route("continue", {}, {}),
        passwordSetup: route("password/setup", {}, {}),
        passwordReset: route("password/reset", {}, {}),
        password: route("password", {}, {}),
        mfaSetup: route("mfa/setup", {}, {}),
        mfa: route("mfa", {}, {}),
        loginSimple: route("login/simple", {}, {}),
        login: route("login", {}, {}),
        logout: route("logout", {}, {}),
        notFound: route("", {}, {}),
      },
    ),
    dashboard: route("/", {}, {}),
    account: route(
      "account",
      {},
      {
        profile: route("", {}, {}),
        security: route("security", {}, {}),
      },
    ),
    admin: route(
      "admin",
      {},
      {
        events: route(
          "events",
          {},
          {
            index: route("", {}, {}),
            rollback: route(
              "rollback&:fundFamilyId",
              {
                fundFamilyId: stringParser,
              },
              {},
            ),
            event: route(
              ":customerEventId",
              {
                customerEventId: stringParser,
              },
              {},
            ),
          },
        ),
      },
    ),
    auditing: route(
      "auditing",
      {},
      {
        index: route("", {}, {}),
      },
    ),
    fundFamilies: route(
      "fund-family",
      {},
      {
        fundFamilyList: route("", {}, {}),
        fundFamily: route(
          ":fundFamilyId",
          {
            fundFamilyId: stringParser,
          },
          {
            index: route("", {}, {}),
            capitalActivity: route(
              "capital-activity",
              {},
              {
                index: route("", {}, {}),
                capitalActivityEvent: route(
                  ":fundFamilyEventId",
                  {
                    fundFamilyEventId: stringParser,
                  },
                  {
                    index: route("", {}, {}),
                    notices: route("notices", {}, {}),
                    calls: route(
                      "calls",
                      {},
                      {
                        capitalActivityCapitalActivityEventAllocation: route(
                          "",
                          {},
                          {},
                        ),
                        capitalActivityCapitalActivityEventBreakdown: route(
                          "breakdown",
                          {},
                          {},
                        ),
                        feeBasisNotification: route(
                          "fee-basis-notification",
                          {},
                          {},
                        ),
                        capitalActivityCapitalActivityCallReallocation: route(
                          "reallocation/:reallocationFundFamilyEventId",
                          {
                            reallocationFundFamilyEventId: stringParser,
                          },
                          {
                            capitalActivityCapitalActivityEventReallocationUpdate:
                              route("", {}, {}),
                            capitalActivityCapitalActivityEventReallocationReview:
                              route("review", {}, {}),
                          },
                        ),
                      },
                    ),
                    distributions: route(
                      "distribution",
                      {},
                      {
                        capitalActivityEventDistributions: route(
                          "distributions",
                          {},
                          {
                            capitalActivityEventDistributionAllocation: route(
                              "",
                              {},
                              {},
                            ),
                            capitalActivityEventDistributionBreakdown: route(
                              "breakdown",
                              {},
                              {},
                            ),
                          },
                        ),
                      },
                    ),
                    equalization: route(
                      "equalization",
                      {},
                      {
                        view: route(
                          ":fundFamilySubEventId",
                          {
                            fundFamilySubEventId: stringParser,
                          },
                          {},
                        ),
                      },
                    ),
                    waterfall: route(
                      "waterfall",
                      {},
                      {
                        review: route(
                          "review/:fundFamilySubEventId/:fundEntityId",
                          {
                            fundFamilySubEventId: stringParser,
                            fundEntityId: stringParser,
                          },
                          {
                            fundPreferredReturn: route(
                              "fund-preferred-return",
                              {},
                              {},
                            ),
                            fund: route("", {}, {}),
                            investorBreakdown: route("investor-level", {}, {}),
                            reviewInvestmentClassifications: route(
                              "investment-classifications",
                              {},
                              {},
                            ),
                            breakdown: route(
                              "breakdown/investor-entity/:investorEntityId",
                              {
                                investorEntityId: stringParser,
                              },
                              {
                                investor: route("", {}, {}),
                                investorPreferredReturn: route(
                                  "investor-preferred-return",
                                  {},
                                  {},
                                ),
                              },
                            ),
                          },
                        ),
                        hybrid: route(
                          "hybrid/:fundFamilySubEventId/:fundEntityId",
                          {
                            fundFamilySubEventId: stringParser,
                            fundEntityId: stringParser,
                          },
                          {
                            status: route("status", {}, {}),
                            summary: route("summary", {}, {}),
                            hybridWaterfallInvestmentReview: route("", {}, {}),
                          },
                        ),
                      },
                    ),
                  },
                ),
              },
            ),
            commitments: route(
              "commitments",
              {},
              {
                tab: route("", {}, {}),
                closingsTab: route("closings", {}, {}),
                transfersTab: route("transfers", {}, {}),
                fee: route(
                  ":commitmentId/fees/:feeId",
                  {
                    commitmentId: stringParser,
                    feeId: stringParser,
                  },
                  {},
                ),
                feeOverride: route(
                  ":commitmentId/fees/:feeId/override",
                  {
                    commitmentId: stringParser,
                    feeId: stringParser,
                  },
                  {},
                ),
                commitment: route(
                  ":commitmentId",
                  {
                    commitmentId: stringParser,
                  },
                  {
                    activity: route("activity", {}, {}),
                    profile: route("profile", {}, {}),
                    fees: route("fees", {}, {}),
                    waterfall: route("waterfall", {}, {}),
                    performance: route("performance", {}, {}),
                  },
                ),
                cancelCorrect: route(
                  "cancel-correct/:commitmentId/:fundFamilyEventId",
                  {
                    commitmentId: stringParser,
                    fundFamilyEventId: stringParser,
                  },
                  {
                    class: route("", {}, {}),
                    feeTrueUp: route("fee-true-up", {}, {}),
                    equalization: route("equalization", {}, {}),
                  },
                ),
                cancelCorrectHistorical: route(
                  "cancel-correct/:commitmentId/:fundFamilyEventId/historical",
                  {
                    commitmentId: stringParser,
                    fundFamilyEventId: stringParser,
                  },
                  {},
                ),
                investorEntities: route(
                  "investor-entities",
                  {},
                  {
                    investorEntity: route(
                      ":investorEntityId",
                      {
                        investorEntityId: stringParser,
                      },
                      {
                        tabActivity: route("activity", {}, {}),
                        tabProfile: route("profile", {}, {}),
                        tabCommitments: route("commitments", {}, {}),
                        tabPerformance: route("performance", {}, {}),
                      },
                    ),
                    investorEntityCommitments: route(
                      ":investorEntityId/commitments",
                      {
                        investorEntityId: stringParser,
                      },
                      {
                        fee: route(
                          ":commitmentId/fees/:feeId",
                          {
                            commitmentId: stringParser,
                            feeId: stringParser,
                          },
                          {},
                        ),
                        feeOverride: route(
                          ":commitmentId/fees/:feeId/override",
                          {
                            commitmentId: stringParser,
                            feeId: stringParser,
                          },
                          {},
                        ),
                        commitment: route(
                          ":commitmentId",
                          {
                            commitmentId: stringParser,
                          },
                          {
                            activity: route("activity", {}, {}),
                            profile: route("profile", {}, {}),
                            fees: route("fees", {}, {}),
                            waterfall: route("waterfall", {}, {}),
                            performance: route("performance", {}, {}),
                          },
                        ),
                        cancelCorrect: route(
                          "cancel-correct/:commitmentId/:fundFamilyEventId",
                          {
                            commitmentId: stringParser,
                            fundFamilyEventId: stringParser,
                          },
                          {
                            class: route("", {}, {}),
                            feeTrueUp: route("fee-true-up", {}, {}),
                            equalization: route("equalization", {}, {}),
                          },
                        ),
                        cancelCorrectHistorical: route(
                          "cancel-correct/:commitmentId/:fundFamilyEventId/historical",
                          {
                            commitmentId: stringParser,
                            fundFamilyEventId: stringParser,
                          },
                          {},
                        ),
                      },
                    ),
                  },
                ),
              },
            ),
            investorTransfers: route(
              "investor-transfers",
              {},
              {
                create: route("create", {}, {}),
                setup: route(
                  "setup/:investorTransferId",
                  {
                    investorTransferId: stringParser,
                  },
                  {
                    details: route("", {}, {}),
                    transferees: route("transferees", {}, {}),
                    documents: route("documents", {}, {}),
                    review: route("review", {}, {}),
                    setupFinalize: route("finalize", {}, {}),
                  },
                ),
                view: route(
                  ":investorTransferId",
                  {
                    investorTransferId: stringParser,
                  },
                  {},
                ),
              },
            ),
            closing: route(
              "closing",
              {},
              {
                edit: route(
                  ":closingId/edit",
                  {
                    closingId: stringParser,
                  },
                  {
                    closingCommitments: route("", {}, {}),
                    equalizationFirstClosingEqualization: route(
                      "equalizationBeforeTrueUp",
                      {},
                      {},
                    ),
                    equalizationFirstClosingFeeTrueUp: route(
                      "feeTrueUpAfterEqualization",
                      {},
                      {},
                    ),
                    equalizationSecondClosingFeeTrueUp: route(
                      "feeTrueUpBeforeEqualization",
                      {},
                      {},
                    ),
                    equalizationSecondClosingEqualization: route(
                      "equalizationAfterTrueUp",
                      {},
                      {},
                    ),
                  },
                ),
              },
            ),
            creditFacilities: route(
              "credit-facility",
              {},
              {
                index: route("", {}, {}),
                creditFacility: route(
                  ":creditFacilityId",
                  {
                    creditFacilityId: stringParser,
                  },
                  {
                    principal: route("principal", {}, {}),
                    expenses: route("expenses", {}, {}),
                    borrowingBase: route("borrowing-base", {}, {}),
                    setup: route(
                      "setup",
                      {},
                      {
                        details: route("", {}, {}),
                        commitments: route("commitments", {}, {}),
                        loan: route("loan", {}, {}),
                        borrowingBase: route("borrowing-base", {}, {}),
                        borrowingBaseReview: route("review", {}, {}),
                      },
                    ),
                    setupInvestorBorrowingBase: route(
                      "setup/borrowing-base/:borrowingBaseGroupId/investors",
                      {
                        borrowingBaseGroupId: stringParser,
                      },
                      {},
                    ),
                    event: route(
                      ":fundFamilyEventId",
                      {
                        fundFamilyEventId: stringParser,
                      },
                      {
                        drawdown: route(
                          "drawdown",
                          {},
                          {
                            update: route("", {}, {}),
                            review: route("review", {}, {}),
                          },
                        ),
                        paydownLegacy: route(
                          "legacy-paydown",
                          {},
                          {
                            creditFacilitiesCreditFacilityEventPaydownUpdateLegacy:
                              route("", {}, {}),
                            creditFacilitiesCreditFacilityEventPaydownReviewLegacy:
                              route("review", {}, {}),
                          },
                        ),
                        paydown: route(
                          "paydown",
                          {},
                          {
                            update: route("", {}, {}),
                            review: route("review", {}, {}),
                          },
                        ),
                        reallocation: route(
                          "reallocation",
                          {},
                          {
                            select: route("", {}, {}),
                            split: route("split", {}, {}),
                            review: route("review", {}, {}),
                          },
                        ),
                        mergeTranches: route(
                          "merge-tranche",
                          {},
                          {
                            creditFacilitiesCreditFacilityEventMergeTranche:
                              route("", {}, {}),
                            creditFacilitiesCreditFacilityEventMergeTrancheReview:
                              route("review", {}, {}),
                          },
                        ),
                        expenses: route(
                          "expenses",
                          {},
                          {
                            post: route("", {}, {}),
                            loan: route(
                              ":loanId",
                              {
                                loanId: stringParser,
                              },
                              {
                                details: route("details", {}, {}),
                                adjust: route("adjust", {}, {}),
                              },
                            ),
                          },
                        ),
                      },
                    ),
                  },
                ),
              },
            ),
            fees: route(
              "fees",
              {},
              {
                index: route("", {}, {}),
                dashboard: route(
                  "dashboard",
                  {},
                  {
                    feePostingTab: route("postings", {}, {}),
                    feeBasisTab: route("basis", {}, {}),
                  },
                ),
                feeChargeEventPosted: route(
                  ":feeChargeEventId/posted",
                  {
                    feeChargeEventId: stringParser,
                  },
                  {
                    breakdown: route("", {}, {}),
                    investor: route("by-investor", {}, {}),
                    use: route("by-use", {}, {}),
                  },
                ),
                feeBreakdownManagementFeeCatchUp: route(
                  ":feeChargeEventId/posted/catch-up",
                  {
                    feeChargeEventId: stringParser,
                  },
                  {},
                ),
                feeBreakdownCancelCorrectFeeAdjustments: route(
                  ":feeChargeEventId/posted/cancel-correct-fee-adjustments",
                  {
                    feeChargeEventId: stringParser,
                  },
                  {},
                ),
                feeBreakdownHistoricalBasisFeeTrueUp: route(
                  ":feeChargeEventId/posted/historical-basis-true-up",
                  {
                    feeChargeEventId: stringParser,
                  },
                  {},
                ),
                post: route(
                  "post/:feeChargeEventId",
                  {
                    feeChargeEventId: stringParser,
                  },
                  {
                    useBreakdown: route("change", {}, {}),
                    reviewBasis: route(
                      "basis",
                      {},
                      {
                        historicalTrueUp: route("historical", {}, {}),
                        breakdown: route("investor", {}, {}),
                      },
                    ),
                    applyOffsets: route("offsets", {}, {}),
                    reviewFees: route("review", {}, {}),
                  },
                ),
                lateOffsets: route(
                  "late-offsets/:feeChargeEventId/:adjustmentFundFamilyEventId",
                  {
                    feeChargeEventId: stringParser,
                    adjustmentFundFamilyEventId: stringParser,
                  },
                  {
                    applyOffsets: route("offsets", {}, {}),
                    reviewFees: route("review", {}, {}),
                  },
                ),
              },
            ),
            setup: route(
              "setup",
              {},
              {
                index: route("", {}, {}),
                commitments: route(
                  "commitments",
                  {},
                  {
                    index: route("", {}, {}),
                    feeOverride: route(
                      ":commitmentId/fees/:feeId/override",
                      {
                        commitmentId: stringParser,
                        feeId: stringParser,
                      },
                      {},
                    ),
                    commitment: route(
                      ":commitmentId",
                      {
                        commitmentId: stringParser,
                      },
                      {
                        basic: route("", {}, {}),
                        letter: route("letter", {}, {}),
                        fees: route("fees", {}, {}),
                        waterfall: route("waterfall", {}, {}),
                      },
                    ),
                  },
                ),
                classes: route(
                  "classes",
                  {},
                  {
                    index: route("", {}, {}),
                    edit: route(
                      ":investorClassId",
                      {
                        investorClassId: stringParser,
                      },
                      {
                        basic: route("", {}, {}),
                        fees: route("fees", {}, {}),
                        waterfall: route("waterfall", {}, {}),
                        commitments: route("commitments", {}, {}),
                      },
                    ),
                    fee: route(
                      ":investorClassId/fees/:feeId",
                      {
                        investorClassId: stringParser,
                        feeId: stringParser,
                      },
                      {},
                    ),
                    feeOverride: route(
                      ":investorClassId/fees/:feeId/override",
                      {
                        investorClassId: stringParser,
                        feeId: stringParser,
                      },
                      {},
                    ),
                  },
                ),
                closing: route(
                  "closing",
                  {},
                  {
                    commitments: route("", {}, {}),
                  },
                ),
                fund: route(
                  "fund",
                  {},
                  {
                    basic: route("", {}, {}),
                    dates: route("dates", {}, {}),
                    feesList: route("fees", {}, {}),
                    waterfall: route("waterfall", {}, {}),
                    calculations: route("calculations", {}, {}),
                    allocations: route("allocations", {}, {}),
                    transactionCodes: route("transaction-codes", {}, {}),
                    fees: route(
                      "fees",
                      {},
                      {
                        add: route("add", {}, {}),
                        view: route(
                          ":feeId",
                          {
                            feeId: stringParser,
                          },
                          {},
                        ),
                        edit: route(
                          "edit/:feeId",
                          {
                            feeId: stringParser,
                          },
                          {},
                        ),
                      },
                    ),
                    calculationCreate: route("calculations/create", {}, {}),
                    calculationEdit: route(
                      "calculations/:transactionCalculationId",
                      {
                        transactionCalculationId: stringParser,
                      },
                      {},
                    ),
                    basisEdit: route(
                      "fee-basis/:feeBasisId",
                      {
                        feeBasisId: stringParser,
                      },
                      {},
                    ),
                    transactionCodesEdit: route(
                      "transaction-codes/edit",
                      {},
                      {},
                    ),
                  },
                ),
                entities: route(
                  "entities",
                  {},
                  {
                    list: route("", {}, {}),
                    allocationsList: route("allocations", {}, {}),
                    entity: route(
                      ":entityId",
                      {
                        entityId: stringParser,
                      },
                      {
                        details: route("", {}, {}),
                        allocationsList: route("allocations", {}, {}),
                        allocations: route(
                          "allocations",
                          {},
                          {
                            create: route("create", {}, {}),
                            edit: route(
                              "edit/:allocationRuleId",
                              {
                                allocationRuleId: stringParser,
                              },
                              {
                                basic: route("", {}, {}),
                                investing: route("entities", {}, {}),
                              },
                            ),
                            setup: route(
                              "setup/:allocationRuleId",
                              {
                                allocationRuleId: stringParser,
                              },
                              {
                                details: route("", {}, {}),
                                entities: route("entities", {}, {}),
                              },
                            ),
                          },
                        ),
                      },
                    ),
                    allocations: route(
                      "allocations",
                      {},
                      {
                        create: route("create", {}, {}),
                        edit: route(
                          "edit/:allocationRuleId",
                          {
                            allocationRuleId: stringParser,
                          },
                          {
                            basic: route("", {}, {}),
                            investing: route("entities", {}, {}),
                          },
                        ),
                        setup: route(
                          "setup/:allocationRuleId",
                          {
                            allocationRuleId: stringParser,
                          },
                          {
                            details: route("", {}, {}),
                            entities: route("entities", {}, {}),
                          },
                        ),
                      },
                    ),
                  },
                ),
                notices: route(
                  "notices",
                  {},
                  {
                    setupNoticesSchema: route("", {}, {}),
                    setupNoticesConfig: route("config", {}, {}),
                    setupNoticesCapitalCall: route("capital-call", {}, {}),
                    setupNoticesDistribution: route("distribution", {}, {}),
                  },
                ),
                creditFacilities: route(
                  "credit-facility",
                  {},
                  {
                    index: route("", {}, {}),
                    creditFacility: route(
                      ":creditFacilityId",
                      {
                        creditFacilityId: stringParser,
                      },
                      {
                        details: route("", {}, {}),
                        loan: route("loans", {}, {}),
                        settingsBorrowingBase: route("borrowing-base", {}, {}),
                      },
                    ),
                    creditFacilitySettingsBorrowingBaseEdit: route(
                      ":creditFacilityId/borrowing-base/:borrowingBaseGroupId",
                      {
                        creditFacilityId: stringParser,
                        borrowingBaseGroupId: stringParser,
                      },
                      {},
                    ),
                  },
                ),
                investorEntities: route(
                  "investor-entities",
                  {},
                  {
                    investorEntity: route(
                      ":investorEntityId",
                      {
                        investorEntityId: stringParser,
                      },
                      {
                        tabActivity: route("activity", {}, {}),
                        tabProfile: route("profile", {}, {}),
                        tabCommitments: route("commitments", {}, {}),
                        tabPerformance: route("performance", {}, {}),
                      },
                    ),
                    investorEntityCommitments: route(
                      ":investorEntityId/commitments",
                      {
                        investorEntityId: stringParser,
                      },
                      {
                        fee: route(
                          ":commitmentId/fees/:feeId",
                          {
                            commitmentId: stringParser,
                            feeId: stringParser,
                          },
                          {},
                        ),
                        feeOverride: route(
                          ":commitmentId/fees/:feeId/override",
                          {
                            commitmentId: stringParser,
                            feeId: stringParser,
                          },
                          {},
                        ),
                        commitment: route(
                          ":commitmentId",
                          {
                            commitmentId: stringParser,
                          },
                          {
                            activity: route("activity", {}, {}),
                            profile: route("profile", {}, {}),
                            fees: route("fees", {}, {}),
                            waterfall: route("waterfall", {}, {}),
                            performance: route("performance", {}, {}),
                          },
                        ),
                        cancelCorrect: route(
                          "cancel-correct/:commitmentId/:fundFamilyEventId",
                          {
                            commitmentId: stringParser,
                            fundFamilyEventId: stringParser,
                          },
                          {
                            class: route("", {}, {}),
                            feeTrueUp: route("fee-true-up", {}, {}),
                            equalization: route("equalization", {}, {}),
                          },
                        ),
                        cancelCorrectHistorical: route(
                          "cancel-correct/:commitmentId/:fundFamilyEventId/historical",
                          {
                            commitmentId: stringParser,
                            fundFamilyEventId: stringParser,
                          },
                          {},
                        ),
                        investorEntities: route(
                          "investor-entities",
                          {},
                          {
                            investorEntity: route(
                              ":investorEntityId",
                              {
                                investorEntityId: stringParser,
                              },
                              {
                                tabActivity: route("activity", {}, {}),
                                tabProfile: route("profile", {}, {}),
                                tabCommitments: route("commitments", {}, {}),
                                tabPerformance: route("performance", {}, {}),
                              },
                            ),
                          },
                        ),
                      },
                    ),
                  },
                ),
              },
            ),
            investments: route(
              "investments",
              {},
              {
                investmentIndex: route("", {}, {}),
                investment: route(
                  ":investmentId",
                  {
                    investmentId: stringParser,
                  },
                  {
                    activity: route("activity", {}, {}),
                    setupProfile: route("", {}, {}),
                  },
                ),
                create: route("create", {}, {}),
              },
            ),
            portfolios: route(
              "portfolios",
              {},
              {
                portfolio: route(
                  ":portfolioId",
                  {
                    portfolioId: stringParser,
                  },
                  {
                    activity: route("activity", {}, {}),
                    profile: route("", {}, {}),
                    investments: route("investments", {}, {}),
                  },
                ),
              },
            ),
            financialReporting: route(
              "financial-reporting",
              {},
              {
                index: route("", {}, {}),
                hypoCreate: route("hypo/create", {}, {}),
                hypoWaterfallEdit: route(
                  ":endOfPeriodReportId/edit",
                  {
                    endOfPeriodReportId: stringParser,
                  },
                  {},
                ),
                hypotheticalWaterfall: route(
                  ":endOfPeriodReportId/hypothetical-waterfall/:hypotheticalWaterfallId",
                  {
                    endOfPeriodReportId: stringParser,
                    hypotheticalWaterfallId: stringParser,
                  },
                  {
                    irr: route("performance/irr", {}, {}),
                    prefBreakdown: route(
                      "waterfall-details/:waterfallTierMappingId/fund/:fundEntityId/pref-breakdown",
                      {
                        waterfallTierMappingId: stringParser,
                        fundEntityId: stringParser,
                      },
                      {},
                    ),
                    investorPrefBreakdown: route(
                      "waterfall-details/:waterfallTierMappingId/fund/:fundEntityId/investor-entity/:investorEntityId/pref-breakdown",
                      {
                        waterfallTierMappingId: stringParser,
                        fundEntityId: stringParser,
                        investorEntityId: stringParser,
                      },
                      {},
                    ),
                    investorWaterfallDetails: route(
                      "fund/:fundEntityId/investor-entity/:investorEntityId/waterfall-details",
                      {
                        fundEntityId: stringParser,
                        investorEntityId: stringParser,
                      },
                      {},
                    ),
                    designateProtectedCarry: route(
                      "designate-protected-carry",
                      {},
                      {},
                    ),
                    review: route(
                      "review",
                      {},
                      {
                        investorNav: route("investor-nav", {}, {}),
                        waterfallDetails: route("waterfall-details", {}, {}),
                        performance: route("performance", {}, {}),
                      },
                    ),
                  },
                ),
              },
            ),
            notFound: route("", {}, {}),
          },
        ),
      },
    ),
    reports: route(
      "reports",
      {},
      {
        availableReportsList: route("", {}, {}),
      },
    ),
    settings: route(
      "settings",
      {},
      {
        users: route("", {}, {}),
      },
    ),
    entities: route(
      "entities",
      {},
      {
        list: route("", {}, {}),
        bulkAddBanks: route("bulk-add-banks", {}, {}),
        bulkAddContacts: route("bulk-add-contacts", {}, {}),
        entity: route(
          ":entityId",
          {
            entityId: stringParser,
          },
          {
            details: route("", {}, {}),
          },
        ),
      },
    ),
    transactions: route("transactions", {}, {}),
    investorEntities: route(
      "investor-entities",
      {},
      {
        investorEntity: route(
          ":investorEntityId",
          {
            investorEntityId: stringParser,
          },
          {
            tabActivity: route("activity", {}, {}),
            tabProfile: route("profile", {}, {}),
            tabCommitments: route("commitments", {}, {}),
            tabPerformance: route("performance", {}, {}),
          },
        ),
        investorEntityCommitments: route(
          ":investorEntityId/commitments",
          {
            investorEntityId: stringParser,
          },
          {
            fee: route(
              ":commitmentId/fees/:feeId",
              {
                commitmentId: stringParser,
                feeId: stringParser,
              },
              {},
            ),
            feeOverride: route(
              ":commitmentId/fees/:feeId/override",
              {
                commitmentId: stringParser,
                feeId: stringParser,
              },
              {},
            ),
            commitment: route(
              ":commitmentId",
              {
                commitmentId: stringParser,
              },
              {
                activity: route("activity", {}, {}),
                profile: route("profile", {}, {}),
                fees: route("fees", {}, {}),
                waterfall: route("waterfall", {}, {}),
                performance: route("performance", {}, {}),
              },
            ),
            cancelCorrect: route(
              "cancel-correct/:commitmentId/:fundFamilyEventId",
              {
                commitmentId: stringParser,
                fundFamilyEventId: stringParser,
              },
              {
                class: route("", {}, {}),
                feeTrueUp: route("fee-true-up", {}, {}),
                equalization: route("equalization", {}, {}),
              },
            ),
            cancelCorrectHistorical: route(
              "cancel-correct/:commitmentId/:fundFamilyEventId/historical",
              {
                commitmentId: stringParser,
                fundFamilyEventId: stringParser,
              },
              {},
            ),
            investorEntities: route(
              "investor-entities",
              {},
              {
                investorEntity: route(
                  ":investorEntityId",
                  {
                    investorEntityId: stringParser,
                  },
                  {
                    tabActivity: route("activity", {}, {}),
                    tabProfile: route("profile", {}, {}),
                    tabCommitments: route("commitments", {}, {}),
                    tabPerformance: route("performance", {}, {}),
                  },
                ),
              },
            ),
          },
        ),
      },
    ),
    internal: route(
      "internal",
      {},
      {
        auditing: route("auditing", {}, {}),
        featureFlags: route("feature-flags", {}, {}),
        featureFlag: route(
          "feature-flags/:featureFlagId",
          {
            featureFlagId: stringParser,
          },
          {
            details: route("details", {}, {}),
            edit: route("edit", {}, {}),
          },
        ),
        provisioning: route(
          "provisioning",
          {},
          {
            customersTab: route("customers", {}, {}),
            usersTab: route("users", {}, {}),
          },
        ),
        customer: route(
          "provisioning/:customerId/customer",
          {
            customerId: stringParser,
          },
          {},
        ),
        shadow: route(
          "shadow",
          {},
          {
            templateTab: route("templates", {}, {}),
            templateLoadTab: route("loads", {}, {}),
            templateExportTab: route("exports", {}, {}),
          },
        ),
        shadowTemplate: route(
          "shadow/:templateVersionId/template",
          {
            templateVersionId: stringParser,
          },
          {
            template: route("", {}, {}),
            templateExport: route(
              ":templateImportExportId/export",
              {
                templateImportExportId: stringParser,
              },
              {},
            ),
            templateLoad: route(
              ":templateImportExportId/load",
              {
                templateImportExportId: stringParser,
              },
              {},
            ),
            templateEvent: route(
              ":templateEventId/event",
              {
                templateEventId: stringParser,
              },
              {},
            ),
          },
        ),
        integrationTesting: route(
          "integration-testing",
          {},
          {
            activity: route("", {}, {}),
            configurations: route("configurations", {}, {}),
            report: route(
              ":integrationTestingReportId/report",
              {
                integrationTestingReportId: stringParser,
              },
              {},
            ),
            reportUpdate: route(
              ":integrationTestingReportId/update",
              {
                integrationTestingReportId: stringParser,
              },
              {},
            ),
            configuration: route(
              "configurations/:integrationTestingConfigurationId",
              {
                integrationTestingConfigurationId: stringParser,
              },
              {},
            ),
          },
        ),
      },
    ),
    investors: route(
      "investors",
      {},
      {
        index: route("", {}, {}),
        investor: route(
          ":investorId",
          {
            investorId: stringParser,
          },
          {
            index: route("", {}, {}),
            activity: route("activity", {}, {}),
            profile: route("profile", {}, {}),
            funds: route("funds", {}, {}),
            performance: route("performance", {}, {}),
            entitiesList: route("investor-entities", {}, {}),
            entities: route(
              "investor-entities",
              {},
              {
                investorEntity: route(
                  ":investorEntityId",
                  {
                    investorEntityId: stringParser,
                  },
                  {
                    tabActivity: route("activity", {}, {}),
                    tabProfile: route("profile", {}, {}),
                    tabCommitments: route("commitments", {}, {}),
                    tabPerformance: route("performance", {}, {}),
                  },
                ),
                investorEntityCommitments: route(
                  ":investorEntityId/commitments",
                  {
                    investorEntityId: stringParser,
                  },
                  {
                    fee: route(
                      ":commitmentId/fees/:feeId",
                      {
                        commitmentId: stringParser,
                        feeId: stringParser,
                      },
                      {},
                    ),
                    feeOverride: route(
                      ":commitmentId/fees/:feeId/override",
                      {
                        commitmentId: stringParser,
                        feeId: stringParser,
                      },
                      {},
                    ),
                    commitment: route(
                      ":commitmentId",
                      {
                        commitmentId: stringParser,
                      },
                      {
                        activity: route("activity", {}, {}),
                        profile: route("profile", {}, {}),
                        fees: route("fees", {}, {}),
                        waterfall: route("waterfall", {}, {}),
                        performance: route("performance", {}, {}),
                      },
                    ),
                    cancelCorrect: route(
                      "cancel-correct/:commitmentId/:fundFamilyEventId",
                      {
                        commitmentId: stringParser,
                        fundFamilyEventId: stringParser,
                      },
                      {
                        class: route("", {}, {}),
                        feeTrueUp: route("fee-true-up", {}, {}),
                        equalization: route("equalization", {}, {}),
                      },
                    ),
                    cancelCorrectHistorical: route(
                      "cancel-correct/:commitmentId/:fundFamilyEventId/historical",
                      {
                        commitmentId: stringParser,
                        fundFamilyEventId: stringParser,
                      },
                      {},
                    ),
                    investorEntities: route(
                      "investor-entities",
                      {},
                      {
                        investorEntity: route(
                          ":investorEntityId",
                          {
                            investorEntityId: stringParser,
                          },
                          {
                            tabActivity: route("activity", {}, {}),
                            tabProfile: route("profile", {}, {}),
                            tabCommitments: route("commitments", {}, {}),
                            tabPerformance: route("performance", {}, {}),
                          },
                        ),
                      },
                    ),
                  },
                ),
              },
            ),
          },
        ),
      },
    ),
    protectedNotFound: route("", {}, {}),
    notFound: route("", {}, {}),
  },
);
